import { Typography, styled } from "@mui/material";

export const StyledTypography = styled(Typography)({
  display: "flex",
  alignItems: "flext-start",
  marginTop: "2rem",
  lineHeight: "1.5rem",
  fontWeight: 700,
});
